import { useState } from "react";
import { Link } from "react-router-dom";
import { portalApi } from "@/lib/PortalContext";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function PortalForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email");
    setBusy(true);
    try {
      await portalApi.post("/portal/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatErr(e));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[color:hsl(var(--background))] flex items-center justify-center px-6 py-14" data-testid="portal-forgot">
      <div className="max-w-md w-full">
        <div className="overline text-center">Subtend Studio · Portal</div>
        <h1 className="font-serif font-light text-center mt-4" style={{ fontSize: "40px", lineHeight: 1.05 }}>
          Reset your password
        </h1>
        {sent ? (
          <div className="luxe-card p-7 mt-10 text-center" data-testid="forgot-sent">
            <div className="font-serif text-2xl mb-3">Check your inbox</div>
            <p className="text-sm text-muted-foreground">
              If <strong>{email}</strong> is registered with your studio, a password reset link is on its way. The link expires in 45 minutes.
            </p>
            <p className="text-xs text-muted-foreground mt-4">You can close this tab — the link in your email will bring you back.</p>
            <Link to="/portal/login" className="btn-outline mt-6 inline-flex"><ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5}/> Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="luxe-card p-7 mt-10 space-y-4" data-testid="forgot-form">
            <p className="text-sm text-muted-foreground">Enter the email address you use for your Subtend Studio portal and we'll send you a link to choose a new password.</p>
            <div>
              <label className="overline text-[10px] block mb-1">Email</label>
              <div className="relative">
                <Mail className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" strokeWidth={1.5}/>
                <input
                  data-testid="input-forgot-email"
                  type="email" autoComplete="email"
                  className="luxe-input pl-9"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit" disabled={busy} data-testid="btn-forgot-submit" className="btn-primary w-full justify-center">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/portal/login" className="text-xs text-muted-foreground hover:text-foreground text-center block mt-2" data-testid="link-back-login">← Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
